"use strict";
exports.__esModule = true;
exports.PieceInventory = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_designer_domain_1 = require("@jewelutions/core-designer-domain");
var PieceInventory = /** @class */ (function () {
    function PieceInventory() {
    }
    PieceInventory.getManyPieceInventorysByPieceModelConfiguration = function (pieceInventorys, pieceReference) {
        return pieceInventorys.filter(function (pi) { return core_designer_domain_1.PieceReference.identical(pi.pieceReference, pieceReference); });
    };
    PieceInventory.getOnePieceInventorysByPieceModelConfiguration = function (pieceInventorys, pieceReference) {
        var result = PieceInventory.getManyPieceInventorysByPieceModelConfiguration(pieceInventorys, pieceReference);
        if (result.length === 0) {
            return undefined;
        }
        if (result.length > 1)
            throw new core_common_domain_1.Exception("Trying to get one piece inventory item but found more than one that match the search criteria.");
        return result[0];
    };
    return PieceInventory;
}());
exports.PieceInventory = PieceInventory;
